module.exports = __webpack_public_path__ + "static/media/pdi-image-07.b9865b83.svg";